import React, { useEffect} from "react";
import {
  Button,
  Form,
  Input,
  Table,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";


//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import {  runInAction, set } from "mobx";
//mobx'


const District = () => {
  //mobx
  const { DistrictStore } = useStore();

  //获得table数据
  useEffect(() => {
    DistrictStore.getDataList();
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(DistrictStore, { page: page, pagesize: pageSize })
    })
    DistrictStore.getDataList()
  }
  //分页控制

 
  // 取消按钮
  const [form] = Form.useForm();


  //表单提交
  const onFinish = async (values) => {
    if(values.name){
      runInAction(() => {
        set(DistrictStore, { title: values.name,page:1})
      })
      await DistrictStore.getDataList();
    }else if(values.name===undefined||values.name===''){
      runInAction(() => {
        set(DistrictStore, {title: '', page:1})
      })
      await DistrictStore.getDataList();
    }

  };


  //table 列表
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "区域代码",
      dataIndex: "code",
    },
    {
      title: "名称",
      dataIndex: "title",
    },
    {
      title: "上级区域代码",
      dataIndex: "pcode",
    }
  ];

  return (
    <>
      <div className="searchBox">
        <Form
          layout="inline"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item label="关键词" name="name">
            <Input placeholder="请输入地区名称" style={{ width: "260px" }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ background: '#40ad63' }}>
              查询
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="TableInput">
        <div className="buttonBox"></div>
        <div className="total">共有数据:{DistrictStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table rowKey={(record) => record.id} columns={columns} dataSource={DistrictStore.dataList} className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: DistrictStore.pagesize,
            current: DistrictStore.page,
            total: DistrictStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
    </>
  );
};

export default observer(District);
